const tableTitleTableActions = {
  title: 'Acciones generadas',
  placeholder: 'Buscar por los campos: ID, acción, problema, pregunta',
};

export default tableTitleTableActions;
